const TIKTOK_VIDEO_TO_ABOUT_ID = {
  '7481711222400847150': 'about-yao-ming-porsche',
  '7506207611688357166': 'about-femslayer-lambo',
  '7463181975772237098': 'about-porcelain-supra',
  '7511018956120001838': 'about-doomslayer-lambo',
  '7519945115075415351': 'about-koi-porsche',
  '7548508011208215863': 'about-mormon-rolls-royce',
  '7515486353837051178': 'about-woody-buzz-drift',
  '7476533914023038250': 'about-chucky-fnaf-meet',
}

const CASE_STUDY_ITEM_TO_ABOUT_ID = {
  'compositing-porcelain-supra': 'about-porcelain-supra',
  'compositing-unreal-engine-3': 'about-chucky-fnaf-meet',
}

/** aboutMedia entries shown as hosted MP4 cards (not TikTok oEmbed) */
export const LOCAL_CAROUSEL_ABOUT_IDS = ['about-bmw-knight-battle']

export const socialCardsToCarouselItems = (cards = [], aboutMedia = []) => {
  const aboutById = Object.fromEntries(aboutMedia.map((entry) => [entry.id, entry]))

  const tiktokItems = cards.map((card) => {
    const aboutId = TIKTOK_VIDEO_TO_ABOUT_ID[card.id]
    const aboutEntry = aboutId ? aboutById[aboutId] : null

    return {
      id: card.id,
      tiktokId: card.id,
      label: aboutEntry?.label || card.label || card.title,
      caption: card.title,
      poster: card.thumbnail,
      isShort: true,
      socialStats: aboutEntry?.socialStats || card.socialStats,
    }
  })

  const localItems = LOCAL_CAROUSEL_ABOUT_IDS.map((aboutId) => aboutById[aboutId])
    .filter(Boolean)
    .map((entry) => ({
      id: entry.id,
      label: entry.label,
      caption: entry.label,
      video: entry.video,
      poster: entry.poster,
      isShort: true,
      socialStats: entry.socialStats,
    }))

  return [...tiktokItems, ...localItems]
}

export const enrichCaseStudyCarouselItems = (items = [], aboutMedia = []) => {
  if (!items.length || !aboutMedia.length) return items

  const aboutById = Object.fromEntries(aboutMedia.map((entry) => [entry.id, entry]))

  return items.map((item) => {
    if (item.socialStats) return item

    const aboutId =
      item.aboutId ||
      CASE_STUDY_ITEM_TO_ABOUT_ID[item.id] ||
      (item.tiktokId ? TIKTOK_VIDEO_TO_ABOUT_ID[item.tiktokId] : null) ||
      (aboutById[item.id] ? item.id : null)

    const aboutEntry = aboutId ? aboutById[aboutId] : null
    if (!aboutEntry?.socialStats) return item

    return {
      ...item,
      socialStats: aboutEntry.socialStats,
    }
  })
}

/**
 * Never pass muted: true — TikTok locks volume when muted=1 in the URL.
 * Autoplay stays off: the player is mounted on the centre card and the only
 * press TikTok honours with sound is one on its own control.
 */
export const TIKTOK_ORIGIN = 'https://www.tiktok.com'

export const getTikTokPlayerSrc = (videoId) => {
  const params = new URLSearchParams({
    controls: '1',
    play_button: '1',
    volume_control: '1',
    progress_bar: '1',
    fullscreen_button: '1',
    timestamp: '1',
    autoplay: '0',
    muted: '0',
    loop: '0',
    music_info: '0',
    description: '0',
    rel: '0',
    native_context_menu: '0',
  })

  return `${TIKTOK_ORIGIN}/player/v1/${videoId}?${params.toString()}`
}

export const postToTikTokPlayer = (iframe, type, value) => {
  if (!iframe?.contentWindow) return

  const message = { type, 'x-tiktok-player': true }
  if (value !== undefined) message.value = value

  iframe.contentWindow.postMessage(message, TIKTOK_ORIGIN)
}
